import React from 'react';
import '../css/privacy-policy.css';

export function PrivacyPolicy() {
    return (
        <main className="privacy-policy-page">
            <div className="privacy-policy-wrap">
                <h1>Privacy Policy</h1>
                <p className="privacy-policy-meta">Last updated: 24 June 2026</p>

                <section>
                    <h2>1. Who we are</h2>
                    <p>
                        RegattaManager provides software tools for organizing and running regattas, including schedules,
                        draws, race status updates, and related administration.
                    </p>
                </section>

                <section>
                    <h2>2. Information we process</h2>
                    <p>Depending on your use of the service, we may process:</p>
                    <ul>
                        <li>Account details such as name, email address, and user role.</li>
                        <li>Competition and meeting data entered by authorized users.</li>
                        <li>Operational logs needed for security, auditing, and troubleshooting.</li>
                        <li>Cookie preferences and basic technical usage information.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. How we use your information</h2>
                    <p>We use information to operate, secure, and improve the service, including to:</p>
                    <ul>
                        <li>Authenticate users and manage access permissions.</li>
                        <li>Provide core regatta functionality and public race information.</li>
                        <li>Maintain audit trails and resolve support issues.</li>
                        <li>Measure service performance when analytics consent is provided.</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Cookies</h2>
                    <p>We use cookies and similar storage technologies for the following purposes:</p>
                    <ul>
                        <li>Essential: required for authentication, security, and core site functionality.</li>
                        <li>Analytics (optional): helps us understand usage trends and improve reliability.</li>
                    </ul>
                    <p>
                        You can choose whether to accept optional analytics cookies through the cookie banner.
                        Essential cookies remain active because they are required for core service operation.
                    </p>
                </section>

                <section>
                    <h2>5. Legal bases</h2>
                    <p>Where applicable, we rely on:</p>
                    <ul>
                        <li>Performance of a contract to provide requested services.</li>
                        <li>Legitimate interests in keeping the platform secure and reliable.</li>
                        <li>Consent for optional analytics cookies.</li>
                    </ul>
                </section>

                <section>
                    <h2>6. Data retention</h2>
                    <p>
                        We retain personal data only as long as needed for operational, legal, and security purposes.
                        Retention periods depend on the data type and applicable legal requirements.
                    </p>
                </section>

                <section>
                    <h2>7. Sharing and processors</h2>
                    <p>
                        We may use trusted service providers (for example, hosting and infrastructure vendors) to
                        process data on our behalf under appropriate contractual safeguards.
                    </p>
                </section>

                <section>
                    <h2>8. Your rights</h2>
                    <p>
                        Subject to applicable law, you may have rights to access, correct, delete, restrict, object,
                        or request portability of your personal data.
                    </p>
                </section>

                <section>
                    <h2>9. Contact</h2>
                    <p>
                        For privacy questions or requests, contact your regatta administrator or email
                        {' '}
                        <a href="mailto:privacy@regattamanager.co.uk">privacy@regattamanager.co.uk</a>.
                    </p>
                </section>
            </div>
        </main>
    );
}
